import * as ACTIONS from '../actions/constants';

const initialState = {
  Authorized: false
};

const setUserData = payload => ({
  Authorized: true,
  Authorization: payload.Authorization,
  userId: payload.retailExperienceUser.username,
  userGuid: payload.retailExperienceUser.userId,
});


function user(state = initialState, action) {
  switch(action.type) {
    case ACTIONS.USER_LOG_OUT:
      return initialState;
    case ACTIONS.USER_LOG_IN:
      return { ...state, userId: action.payload.username, ...setUserData(action.payload) };
    case ACTIONS.USER_UPDATE_DETAILS:
      return { ...state, data: action.payload };
    default:
      return state;
  }
}

export default user;



// WEBPACK FOOTER //
// ./src/reducers/user.js